import * as React from 'react'
import map from 'lodash/map'
import Input from '@frontrow/console/src/entities/components/base/input'
import {Button} from '@frontrow/console/src/components/button'
import {
  GenericSelector,
  createSelectorOptionAsItem,
  type SelectorItemT
} from '@frontrow/console/src/components/generic-selector'

// Models
import {
  type IdpOverlayStudentPOST,
  type IdpT,
  type IdpOverlayT
} from '@frontrow/console/src/models/idp-overlay-student.types'
import FormField from '@frontrow/console/src/components/common/form-field'

type Props = {
  overlay?: IdpOverlayStudentPOST
  onSubmit: (data: IdpOverlayStudentPOST) => Promise<unknown>
}

const IDP_OPTIONS = map(
  [
    ['clever', 'Clever'],
    ['class-link', 'ClassLink']
  ],
  ([id, name]) => createSelectorOptionAsItem(id, name)
)
const OVERLAY_TYPE_OPTIONS = map(
  [
    ['first-name', 'First Name'],
    ['last-name', 'Last Name'],
    ['grade', 'Grade']
  ],
  ([id, name]) => createSelectorOptionAsItem(id, name)
)

export default function IdpOverlayStudentForm(props: Props): React.ReactElement {
  const {overlay} = props

  const [formData, setFormData] = React.useState<IdpOverlayStudentPOST>({
    idp: overlay ? overlay.idp : 'clever',
    idpId: overlay ? overlay.idpId : '',
    type: overlay ? overlay.type : 'first-name',
    value: overlay ? overlay.value : ''
  })

  const onChange = <Key extends keyof IdpOverlayStudentPOST>(
    prop: Key
  ): ((value: IdpOverlayStudentPOST[Key]) => void) => {
    return (value: IdpOverlayStudentPOST[Key]) => {
      setFormData(prevState => ({...prevState, [prop]: value}))
    }
  }

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    props.onSubmit(formData)
  }

  return (
    <form onSubmit={onSubmit} action="">
      <FormField label="IdP" required>
        <GenericSelector
          selection={formData.idp}
          collection={IDP_OPTIONS as SelectorItemT<IdpT>[]}
          onChangeSelection={onChange('idp')}
          required
        />
      </FormField>
      <FormField label="IdP ID" required>
        <Input value={formData.idpId} type="text" onChange={onChange('idpId')} required />
      </FormField>
      <FormField label="Type" required>
        <GenericSelector
          selection={formData.type}
          collection={OVERLAY_TYPE_OPTIONS as SelectorItemT<IdpOverlayT>[]}
          onChangeSelection={onChange('type')}
          required
        />
      </FormField>
      <FormField label="Value" required>
        <Input value={formData.value} type="text" onChange={onChange('value')} required />
      </FormField>
      <Button type="submit">Create Overlay</Button>
    </form>
  )
}
